// @givmo/assistant-panel — a vocabulary that names nothing beyond what this package can honestly say.
//
// Hosts are expected to pass their own; this exists so a test, a story or an early mount is not
// forced to author a dozen strings, and so no default lives in two places.
//
// ⚠ EVERY STRING HERE IS DELIBERATELY CLASS-NEUTRAL — "your organization", "your portal", and
// nothing narrower. A default that named one kind of organization would put the fork this package
// exists to avoid into the one file every host inherits from, and it would arrive as a default
// nobody chose. `panel-generic.test.ts` scans for exactly that, comments included.

import type { AssistantVocab } from './assistant-panel-config';

export function defaultAssistantVocab(): AssistantVocab {
  return {
    productName: 'Assistant',
    composerPlaceholder: 'Ask a question…',
    emptyTitle: 'Ask about your organization.',
    emptyBody: 'I can read what is in your portal and draft text for you to use.',
    copyAction: 'Copy',
    insertAction: 'Insert',
    // No exclamation, no apology, no error code. The conversation did not work; that is the whole
    // fact, and the retry is beside it.
    failedLine: 'We couldn’t get a reply.',
    failedRetry: 'Try again',
    stopLabel: 'Stop',
    sendLabel: 'Send',
    consentTitle: 'Turn on the assistant for {org}',
    consentScopeLine:
      'You’re turning this on for {org}. Any of your admins will be able to use it.',
    consentDecline: 'Not now',
    consentAccept: 'Turn on assistant',
    noticeScopeLine: '{org} turned this on.',
    noticeDismiss: 'Got it.',
    consentBlockedLine: 'An owner needs to turn this on for {org}.',
    unavailableLine: 'The assistant isn’t available here yet.',
    policyLinkPhrase: 'Privacy Policy',
  };
}
